import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import Login from '@/pages/Login';
import EmployeeDashboard from '@/pages/EmployeeDashboard';
import AdminDashboard from '@/pages/AdminDashboard';
import Profile from '@/pages/Profile';
import Attendance from '@/pages/Attendance';
import Documents from '@/pages/Documents';
import Payslips from '@/pages/Payslips';
import LeaveLedger from '@/pages/LeaveLedger';
import Policies from '@/pages/Policies';
import AdminEmployees from '@/pages/AdminEmployees';
import AdminAttendance from '@/pages/AdminAttendance';
import AdminAttendanceSummary from '@/pages/AdminAttendanceSummary';
import AdminSalaryRules from '@/pages/AdminSalaryRules';
import AdminProcessSalary from '@/pages/AdminProcessSalary';
import AdminHolidays from '@/pages/AdminHolidays';
import AdminDocuments from '@/pages/AdminDocuments';
import AdminPolicies from '@/pages/AdminPolicies';
import { Toaster } from '@/components/ui/sonner';

const ProtectedRoute = ({ children, requiredRole }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  if (!token) {
    return <Navigate to="/login" />;
  }
  
  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to="/" />;
  }
  
  return children;
};

function App() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const defaultRoute = user.role === 'admin' ? '/admin/dashboard' : '/dashboard';

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to={localStorage.getItem('token') ? defaultRoute : '/login'} />} />
          
          <Route path="/dashboard" element={
            <ProtectedRoute requiredRole="employee">
              <EmployeeDashboard />
            </ProtectedRoute>
          } />
          <Route path="/profile" element={
            <ProtectedRoute requiredRole="employee">
              <Profile />
            </ProtectedRoute>
          } />
          <Route path="/attendance" element={
            <ProtectedRoute requiredRole="employee">
              <Attendance />
            </ProtectedRoute>
          } />
          <Route path="/documents" element={
            <ProtectedRoute requiredRole="employee">
              <Documents />
            </ProtectedRoute>
          } />
          <Route path="/payslips" element={
            <ProtectedRoute requiredRole="employee">
              <Payslips />
            </ProtectedRoute>
          } />
          <Route path="/leave-ledger" element={
            <ProtectedRoute requiredRole="employee">
              <LeaveLedger />
            </ProtectedRoute>
          } />
          <Route path="/policies" element={
            <ProtectedRoute requiredRole="employee">
              <Policies />
            </ProtectedRoute>
          } />
          
          <Route path="/admin/dashboard" element={
            <ProtectedRoute requiredRole="admin">
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/employees" element={
            <ProtectedRoute requiredRole="admin">
              <AdminEmployees />
            </ProtectedRoute>
          } />
          <Route path="/admin/attendance" element={
            <ProtectedRoute requiredRole="admin">
              <AdminAttendance />
            </ProtectedRoute>
          } />
          <Route path="/admin/attendance-summary" element={
            <ProtectedRoute requiredRole="admin">
              <AdminAttendanceSummary />
            </ProtectedRoute>
          } />
          <Route path="/admin/salary-rules" element={
            <ProtectedRoute requiredRole="admin">
              <AdminSalaryRules />
            </ProtectedRoute>
          } />
          <Route path="/admin/process-salary" element={
            <ProtectedRoute requiredRole="admin">
              <AdminProcessSalary />
            </ProtectedRoute>
          } />
          <Route path="/admin/holidays" element={
            <ProtectedRoute requiredRole="admin">
              <AdminHolidays />
            </ProtectedRoute>
          } />
          <Route path="/admin/documents" element={
            <ProtectedRoute requiredRole="admin">
              <AdminDocuments />
            </ProtectedRoute>
          } />
          <Route path="/admin/policies" element={
            <ProtectedRoute requiredRole="admin">
              <AdminPolicies />
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
